module.exports = __webpack_public_path__ + "static/media/level-zero.bf5d6abe.svg";